<div class="select-chip">
  <mat-chip-option
    class="chip"
    color="primary"
    matTooltip="{{ 'NGX-MESSAGING.FILTER.' + (selector?.tooltip || selector?.name) | translate }}"
    [ngClass]="{ 'chip--active': $safeNavigationMigration(selector?.value) !== null }"
    [selected]="$safeNavigationMigration(selector?.value) !== null"
    [matMenuTriggerFor]="selectorMenu">
    {{ 'NGX-MESSAGING.FILTER.' + filterName() | translate }}
  </mat-chip-option>
</div>

<mat-menu #selectorMenu>
  @for (option of selector?.options || []; track option.value) {
  <button (click)="setValue(option.value)" mat-menu-item>
    {{ 'NGX-MESSAGING.FILTER.' + option.name | translate }}
  </button>
  }
</mat-menu>
